import { createApi } from '@reduxjs/toolkit/query/react';
import { SettingsNotificationsDto, SettingsServiceFunctionsDto, SettingsTrustedIpsDto } from '@sr/dto';
import { SETTINGS_BASE_URL } from 'shared/api/api';
import { createBaseQuery } from 'shared/api/rtk-query';

const api = createApi({
  baseQuery: createBaseQuery(SETTINGS_BASE_URL),
  endpoints: (builder) => ({
    getTrustedIpsSettings: builder.query<SettingsTrustedIpsDto, void>({
      query: () => 'trusted-ips',
    }),
    setTrustedIpsSettings: builder.mutation<SettingsTrustedIpsDto, SettingsTrustedIpsDto>({
      query: (data) => ({
        url: 'trusted-ips',
        method: 'PUT',
        body: data,
      }),
    }),
    getServiceFunctionsSettings: builder.query<SettingsServiceFunctionsDto, void>({
      query: () => 'service-functions',
    }),
    setServiceFunctionsSettings: builder.mutation<SettingsServiceFunctionsDto, SettingsServiceFunctionsDto>({
      query: (data) => ({
        url: 'service-functions',
        method: 'PUT',
        body: data,
      }),
    }),
    getNotificationsSettings: builder.query<SettingsNotificationsDto, void>({
      query: () => 'notifications',
    }),
    setNotificationsSettings: builder.mutation<SettingsNotificationsDto, SettingsNotificationsDto>({
      query: (data) => ({
        url: 'notifications',
        method: 'PUT',
        body: data,
      }),
    }),
  }),
});

export const settingsApi = api.enhanceEndpoints({ addTagTypes: ['settings', 'lead-sources'] });
